import { render } from "./SimpleTimeline.vue?vue&type=template&id=56068790"
import script from "./SimpleTimeline.vue?vue&type=script&lang=js"
export * from "./SimpleTimeline.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QVirtualScroll from 'quasar/src/components/virtual-scroll/QVirtualScroll.js';
import QTimeline from 'quasar/src/components/timeline/QTimeline.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QVirtualScroll,QTimeline,QBtn});
